<button mat-icon-button (click)="jobSearch()">
  <mat-icon [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
</button>
